import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeletePropertyAmenityMutation, useGetPropertyAmenityByIdQuery } from "../../../services/bClientApi"
import PropertyAmenityEntry from "../../../Components/PropertyAmenity/PropertyAmenityEntry/PropertyAmenityEntry"

export default function DeletePropertyAmenityPage() {

    const [
        deletePropertyAmenity,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeletePropertyAmenityMutation()

    const { propertyAmenityId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading
    } = useGetPropertyAmenityByIdQuery(propertyAmenityId, { skip: !propertyAmenityId || deleteClicked })
    const propertyAmenityData = data || {}

    const propertyAmenityDeleteFn = async () => {
        if (propertyAmenityId) {
            const deleteValue = await deletePropertyAmenity(propertyAmenityId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo('/property-amenities/'))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Property Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {propertyAmenityId && propertyAmenityData && !isLoading && (
                        <div className="property-amenity-info">
                            <div className="mb-4">
                                <h4>Property Amenity to Delete</h4>
                                <PropertyAmenityEntry
                                    propertyAmenityData={propertyAmenityData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this property amenity? This action cannot be undone.
                                </div>
                                <div>
                                    <Button
                                        variant="secondary"
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/property-amenity/${propertyAmenityId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="warning"
                                        onClick={() => setDeleteClicked(true)}
                                        disabled={deleteClicked}
                                    >
                                        Delete Property Amenity
                                    </Button>
                                </div>
                                {deleteClicked && (
                                    <div className="alert alert-danger">
                                        <strong>Final Confirmation:</strong> This property amenity will be permanently deleted. This action cannot be undone.
                                        <br /><br />
                                        <Button
                                            variant="danger"
                                            disabled={deleteLoading}
                                            onClick={() => {
                                                propertyAmenityDeleteFn()
                                            }}
                                        >
                                            {deleteLoading ? 'Deleting...' : 'Confirm Delete Property Amenity'}
                                        </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
